/**
 * 城北街道，家风文明
 */

import axios from "@/utils/request"

export const addJfwmUser = (data) => {
  return axios.request({
    url: "a2022/jfwm/add_user",
    method: "POST",
    data
  })
}

export const addJfwmPic = (data) => {
  return axios.request({
    url: "a2022/jfwm/add_pic",
    method: "POST",
    data
  })
}

export const myJfwmPic = () => {
  return axios.request({
    url: "a2022/jfwm/my_pic",
    method: "get"
  })
}

export const hasUser = () => {
  return axios.request({
    url: "a2022/jfwm/has_user",
    method: "GET",
  })
}
